{
    "h1": ["headline", "is-level-1"],
    "h2": ["headline", "is-level-2"],
    "h3": ["headline", "is-level-3"],
    "h4": ["title", "is-level-1"],
    "h5": ["title", "is-level-2"],
    "h6": ["title", "is-level-3"],
    "p": "text",
    "a": "link",
    "ul": "list",
    "ol": "list",
    "hr": "is-divider",
    "table": ["table", "is-bordered", "is-fullwidth"],
    "em": "is-italic"
}
